import type { components } from '@feedfm/clips-services-api';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import * as styles from './Explicitness.styles';

type Explicitness = components['schemas']['Explicitness'];

export interface ExplicitnessProps {
  explicitness: Explicitness;
}

function getLabel(explicitness: Explicitness) {
  switch (explicitness) {
    case 'explicit':
      return 'Explicit';
    case 'censored':
      return 'Censored';
    default:
      return null;
  }
}

export const Explicitness = ({ explicitness }: ExplicitnessProps) => {
  const label = useMemo(() => getLabel(explicitness), [explicitness]);
  return label ? <Box sx={styles.pill}>{label}</Box> : null;
};
